import { useState } from "react";
import { HiPencilAlt } from "react-icons/hi";
import { LuTrash2 } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { FaTrophy } from "react-icons/fa";

const TournamentCard = ({
  tournament,
  onEdit,
  onDelete,
  basePath,
  isPublicView = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = (id) => navigate(`/${basePath}/${id}`);

  const isValidImage = tournament.imageSrc && tournament.imageSrc.trim() !== "";

  const formatDate = (dateString) => {
    if (!dateString) return "Fecha no definida";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES");
  };

  return (
    <div
      className="relative bg-white rounded-2xl shadow-md p-4 flex items-center gap-4 transition hover:shadow-lg cursor-pointer mb-4"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => handleClick(tournament.id)}
    >
      {/* Botones de acción */}
      {!isPublicView && isHovered && (
        <div className="absolute top-2 right-2 flex flex-col gap-2">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEdit(tournament);
            }}
            className="p-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition"
          >
            <HiPencilAlt size={16} />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(tournament.id);
            }}
            className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition"
          >
            <LuTrash2 size={16} />
          </button>
        </div>
      )}

      {/* Imagen */}
      <div className="w-1/3 h-24 flex items-center justify-center rounded-xl overflow-hidden bg-gray-100">
        {isValidImage ? (
          <img
            src={tournament.imageSrc}
            alt={tournament.columnTitle}
            className="w-full h-full object-cover"
          />
        ) : (
          <FaTrophy size={32} className="text-gray-400" />
        )}
      </div>

      {/* Información */}
      <div className="w-2/3">
        <h2 className="text-md font-semibold text-gray-800">
          {tournament.columnTitle}
        </h2>
        <p className="text-sm text-gray-500 mt-1">{tournament.text1}</p>
        <p className="text-sm text-gray-500 mt-1">{tournament.text2}</p>
        {tournament.startDate && (
          <p className="text-xs text-gray-400 mt-1">
            {formatDate(tournament.startDate)} -{" "}
            {formatDate(tournament.endDate) || "Sin fecha final"}
          </p>
        )}
      </div>
    </div>
  );
};

export default TournamentCard;
